import React from "react";
import type { BlockTextImportT } from "../../../../../../schema/block/text";
import { Text } from "@ui/IconV2/react";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";

export const icon = () => <Text size="l" color={colors.carbon800} />;

export const title = t("project.dashboard.block.template.text.title");

export const description = null;

export const block: Omit<BlockTextImportT, "dashboardId" | "position"> = {
  kind: "TEXT",
  data: "",
};
